import { render } from "./Complain.vue?vue&type=template&id=1986bcbe&scoped=true"
import script from "./Complain.vue?vue&type=script&lang=js"
export * from "./Complain.vue?vue&type=script&lang=js"

import "./Complain.vue?vue&type=style&index=0&id=1986bcbe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1986bcbe"]])

export default __exports__